<template>
  <ReportSection
    :columns="1"
    data-test-id="ValueReport_vendorConsolidationCard"
    title="Vendor Consolidation"
  >
    <PricingComparison
      :planMonthlyPrice="pricePerUser"
      :planName="planName"
      :productCode="productCode"
      :showTagline="true"
      :usersCount="usersCount"
    />
  </ReportSection>
</template>

<script>
import PricingComparison from 'client/Pricing/PricingCalculator/PricingComparison.vue';

import ReportSection from './ReportSection.vue';

export default {
  name: 'VendorConsolidationCard',

  components: {
    PricingComparison,
    ReportSection,
  },

  props: {
    metrics: {
      default: () => ({}),
      type: Object,
    },
    usersCount: {
      default: 0,
      type: Number,
    },
  },

  computed: {
    planName() {
      return this.metrics.plan && this.metrics.plan.name
        ? this.metrics.plan.name
        : 'Free';
    },

    pricePerUser() {
      return this.metrics.plan && this.metrics.plan.pricePerUser
        ? this.metrics.plan.pricePerUser
        : 0;
    },

    productCode() {
      return this.metrics.plan && this.metrics.plan.productCode
        ? this.metrics.plan.productCode
        : 'Free';
    },
  },
};
</script>
